/* eslint-disable import/prefer-default-export */
import { userPreferenceDefaults } from '@/defaults'
import { UserColumnPref, UserPreference } from '@domain'
import { isJsonObjOrArr } from '@utils/stringHelpers'

export function mergePreferences(preferences: UserPreference[]) {
	const preferencesWithDefaults = userPreferenceDefaults.map((pref) => {
		const apiValue = preferences.find((p) => p.key === pref.key)
		if (apiValue) {
			// All the values in user preferences are strings, so we need to convert
			// them to booleans when needed
			if (apiValue.value === 'true' || apiValue.value === 'false') {
				return { key: apiValue.key, value: apiValue.value === 'true' }
			}
			// Converting value to a number if value can be coerced into a number
			const numberValue = Number(apiValue.value)
			if (Number.isFinite(numberValue)) {
				return { key: apiValue.key, value: numberValue }
			}
			// Converting value to an object if value can be parsed to a JSON obj or array
			if (isJsonObjOrArr(apiValue.value as string)) {
				return { key: apiValue.key, value: JSON.parse(apiValue.value as string) }
			}
		}
		return pref
	})

	return preferencesWithDefaults
}

export function colPrefsAreValid(prefs: UserColumnPref[], defaults: UserColumnPref[]) {
	if (prefs.length !== defaults.length) return false

	const prefFields = prefs.map((p) => p.field).sort()
	const defaultFields = defaults.map((d) => d.field).sort()

	return prefFields.every((field, i) => field === defaultFields[i])
}
